import {API_ENTRYPOINT} from '@/config/entrypoint';

// Sdilena API vrstva pro journey domenu - vraci presne tvar {url, obj, method},
// ktery ocekava journey/positionPost a journey/fetchObject store akce.

function post(path, obj) {
    return {url: new URL(path, API_ENTRYPOINT), obj, method: 'POST'};
}

function get(path) {
    return {url: new URL(path, API_ENTRYPOINT), obj: null, method: 'GET'};
}

function patch(path, obj) {
    return {url: new URL(path, API_ENTRYPOINT), obj, method: 'PATCH'};
}

// bez cityId/stepCost = presuny bez cile (napr. City -> Wild);
// s cityId (+ volitelnym stepCost) = presun na konkretni mesto ("vlak")
export function travel(positionId, cityId = undefined, stepCost = undefined) {
    const obj = {positionId};
    if (cityId !== undefined) {
        obj.cityId = cityId;
    }
    if (stepCost !== undefined) {
        obj.stepCost = stepCost;
    }
    return post('api/travel', obj);
}

export function registerLeague(positionId) {
    return post('api/register-league', {positionId});
}

export function goToPrepareFight(positionId) {
    return post('api/go-to-prepare-fight', {positionId});
}

// SETTYPE prechod LEAGUE_OAK -> LEAGUE_FIGHT (souper vzdy urceny serverem
// z position.league.nextOpponent, stejne jako stara LeagueOak.vue - zadny
// trainerId se neposila)
export function meetLeagueTrainer(positionId) {
    return post('api/meet-league-trainer', {positionId});
}

export function meetMewtwo() {
    return post('api/meet-mewtwo', {});
}

// SETTYPE prechod CITY -> zadny (heal je akce uvnitr CITY, POKE_CENTER stav neexistuje)
export function pokeCenter(positionId) {
    return get('api/poke-center/' + positionId);
}

// SETTYPE prechod CITY -> OAK
export function visitOak(positionId) {
    return post('api/visit-oak', {positionId});
}

// SETTYPE prechod CITY -> OFFICER_JENNY
export function visitOfficerJenny(positionId) {
    return post('api/visit-officer-jenny', {positionId});
}

// SETTYPE prechod CITY -> FIGHT_TRAINER (stadionFight=true)
export function meetStadionTrainer(positionId, trainerId) {
    return post('api/meet-trainer', {positionId, trainerId, stadionFight: true});
}

// SETTYPE prechod WILD -> FIGHT_TRAINER (stadionFight=false), maxPokemons = kolik
// pokemonu na strane hrace (1v1/2v2/3v3, viz stara Wild.vue - "max" pocitany
// z wildTrainer.travellingPokemonsCount, strop na 3)
export function meetWildTrainer(positionId, trainerId, maxPokemons) {
    return post('api/meet-trainer', {positionId, trainerId, stadionFight: false, maxPokemons});
}

// dalsi krok v dungeonu (jak prvni vstup, tak pokracovani jiz rozjeteho -
// viz stara Wild.vue goToDungeon())
export function goDungeon(positionId, stepCost = 3) {
    return post('api/go-dungeon', {positionId, stepCost});
}

export function startDungeonChallenge(positionId, stepCost = 7) {
    return post('api/start-dungeon-challenge', {positionId, stepCost});
}

// hint moznych prekazek pro danou lokalitu (obycejny dungeon - specificky
// pro environment; challenge pouziva vsechny typy, viz obstacleTypes() nize)
export function getObstacleHint(environment) {
    return get('api/get-obstacle-hint/' + environment);
}

export function obstacleTypes() {
    return get('api/obstacle_types');
}

export function setPositionType(positionId, type) {
    return patch('api/positions/' + positionId, {positionId, type});
}

export function citiesList(filter = '') {
    return get('api/cities?&order[id]=desc' + filter);
}

// detail trenera (napr. wildTrainer u WildNext.vue - `wild.wildTrainerId`
// vraci jen id, potreba dotahnout jmeno/obrazek/travellingPokemonsCount zvlast)
export function trainerDetail(trainerId) {
    return get('api/trainers/' + trainerId);
}

// napoveda na prekazky konkretniho trenera stadionu (TrainerFightWin/Next -
// na rozdil od getObstacleHint() vyse, ktera je podle environmentu)
export function getTrainerObstacleHint(trainerId) {
    return get('api/get-trainer-obstacle-hint/' + trainerId);
}

// zebricek pro dany odznak (Glory list na TrainerFightWin/Next) - omezeno na top 10
export function badgeToplist(badgeId) {
    return get('api/badge_toplists?order[day]=asc&page=1&itemsPerPage=10&badge=' + badgeId);
}

// zebricek pro TrainerWildFightWin/Next (Glory list po vyhre nad divokym
// trenerem) - `wildTrainerId` musi byt id PORAZENEHO NPC trenera
// (`trainerFight.trainer.id`), backend (GetTrainersToplistAction) filtruje
// `wild_trainer_id = ?` v `wild_trainer_toplist`, kam se pri vyhre uklada
// prave `trainerFight.getTrainer()` (viz FightAction.php) - NE `user.id`
// (id PRIHLASENEHO hrace).
export function trainersToplist(day, wildTrainerId) {
    return get('api/get-trainers-toplist?day=' + day + '&wildTrainer=' + wildTrainerId);
}

// zebricek pro DungeonWin/DungeonChallengeWin(Next) - Glory list dungeonu;
// isChallenge rozlisuje normalni dungeon vs. Dungeon Challenge toplist
// (backend GetDungeonsToplistAction filtruje podle stejneho parametru)
export function dungeonsToplist(day, trainerId, isChallenge = false) {
    let path = 'api/get-dungeons-toplist?day=' + day + '&trainer=' + trainerId;
    if (isChallenge) {
        path += '&isChallenge=true';
    }
    return get(path);
}

// "Winners of the cup" zebricek na LeagueWin/LeagueLose(Next) - entita
// LeagueToplist ma pole `day`, ne `days` (API Platform neplatny filtr tise ignoruje)
export function leagueToplists() {
    return get('api/league_toplists?order[day]=asc&order[created]=asc&page=1&itemsPerPage=100');
}
